class PromoCode extends HTMLElement {
  constructor() {
    super();

    // Get the input and submit button elements
    const promoInput = document.querySelector('.promo-input');
    const submitButton = document.querySelector('.btn-submit');
    const tag = document.querySelector('.tag-close');
    const errorMessage = document.querySelector('.promo-error');
    const errorMessageGC = document.querySelector('.promo-error-gc');
    const errorMessageFS = document.querySelector('.promo-error-fs');

    // Disable the submit button initially if the input is empty
    if (promoInput && submitButton) {
      submitButton.disabled = promoInput.value.trim() === '';
      submitButton.style.backgroundColor = promoInput.value.trim() === '' ? '#d3d5d8' : 'black';
      submitButton.style.color = promoInput.value.trim() === '' ? '#92959B' : 'white';

      // Add event listener to the input field to enable/disable the submit button
      promoInput.addEventListener('input', function () {
        submitButton.disabled = promoInput.value.trim() === '';
        submitButton.style.backgroundColor = promoInput.value.trim() === '' ? '#d3d5d8' : 'black';
        submitButton.style.color = promoInput.value.trim() === '' ? '#92959B' : 'white';
      });

      // Add event listener to the submit button to set session storage
      submitButton.addEventListener('click', function (e) {
        e.preventDefault();
        let cartHasGiftCard = false;
        if (window.cart && window.cart.items) {
          cartHasGiftCard = window.cart.items.some((item) => item.product_type.includes('GIVEX'));
          if (cartHasGiftCard) {
            sessionStorage.setItem('promoCode', '');
          } else {
            sessionStorage.setItem('promoCode', promoInput.value.trim());
          }
        }
      });

      // Add hover state event listeners
      submitButton.addEventListener('mouseenter', function () {
        if (!submitButton.disabled) {
          submitButton.style.backgroundColor = '#efe8f8';
          submitButton.style.color = 'black';
        }
      });

      submitButton.addEventListener('mouseleave', function () {
        if (!submitButton.disabled) {
          submitButton.style.backgroundColor = 'black';
          submitButton.style.color = 'white';
        }
      });
    }
    if (tag) {
      tag.addEventListener('click', function () {
        sessionStorage.setItem('promoCode', '');
        window.location.href = "/discount/''?redirect=/cart";
      });
    }
    // Check session storage on load
    window.addEventListener('load', function () {
      const storedPromoCode = sessionStorage.getItem('promoCode');

      if (promoInput.value != '') {
        promoInput.value = '';
      }

      if (storedPromoCode && !window.discount_tag) {
        if (
          (window.cart.items.length == 1 && window.cart.items[0].price % 100 === 97) ||
          window.cart.items[0].price % 100 === 96
        ) {
          errorMessageFS.style.display = 'block';
          setTimeout(function () {
            errorMessageFS.style.display = 'none';
          }, 10000);
        } else if (window.gift_card_cart == true) {
          errorMessageGC.style.display = 'block';
          setTimeout(function () {
            errorMessageGC.style.display = 'none';
          }, 10000);
        } else {
          errorMessage.style.display = 'block';
          setTimeout(function () {
            errorMessage.style.display = 'none';
          }, 10000);
        }
      } else {
        errorMessage.style.display = 'none';
      }
      sessionStorage.setItem('promoCode', '');
    });
  }
}

export class StickyCheckout extends HTMLElement {
  constructor() {
    super();

    const checkoutButtonRef = document.querySelector(
      '.CartTotals__summary-estimation-wrapper + .CartTotals__checkout-button',
    );

    const isVisibleInViewport = (element) => {
      // It will detect that element as soon as the sticky button replaces the inline button's y coordinate
      // That's why, we need to take into account Total Savings height section in Sticky Checkout
      const rect = element.getBoundingClientRect();
      const gap = 50; // Total savings height section

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) - gap &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    const isFartherInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top < 0;
    };

    // Trigger it just for mobile devices.
    window.innerWidth < 786 &&
      document.addEventListener('scroll', () => {
        // The Sticky Checkout cannot be rendering beyond Price Breakdown or Cart Total Summary
        if (isVisibleInViewport(checkoutButtonRef) || isFartherInViewport(checkoutButtonRef)) {
          this.style.display = 'none';
        } else {
          this.style.display = '';
        }
      });
  }
}

export default PromoCode;
